import type { LeadInvestorProps } from "@/types";
import { useRef, type FC } from "react";
import SplitTextAnimation from "../split-text-animation";
import { useInView } from "@/hooks/reveal-in-view";
import { Image } from "../image";

export const LeadInvestor: FC<LeadInvestorProps> = ({title, image}) => {
    const ref = useRef(null);
    const isInView = useInView(ref, { once: true, margin: "0px 0px 25% 0px" });
    return (
      <section className="leadInvestor">
				<div className="wrapper">
					<SplitTextAnimation
						htmlElement={
						<h2 className="leadInvestor--title" ref={ref}>
							{title}
						</h2>
						}
						isInView={isInView}
					/> 
					<div className="leadInvestor--imageWrapper">
						{image.file?.url && 
							<Image
								className="leadInvestor--bg"
								src={image as any}
								alt={image.title}
								animateInView
							/>
						}
					</div>
				</div>
      </section>
    )
}